import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=525fd976&scoped=true&"
import script from "./fileViewer.vue?vue&type=script&lang=js&"
export * from "./fileViewer.vue?vue&type=script&lang=js&"
import style0 from "./fileViewer.vue?vue&type=style&index=0&id=525fd976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fd976",
  null
  
)

export default component.exports